import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ImmersivePage } from "@/components/ImmersivePage";

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#0E1E30",
            border: "1px solid rgba(201, 168, 76, 0.2)",
            color: "#F2EDE4",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ImmersivePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
